var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'is-not-app': !_vm.isApp,
    'common-fixed-points': true,
    show: _vm.show
  }},[_vm._t("default",null,{"scrollTop":_vm.scrollTop,"show":_vm.show})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }